module.exports = __webpack_public_path__ + "img/gmo-pc.e1667f96.png";